<template>
    <section class="quote light purple">
        <circles-layout></circles-layout>

        <v-quote>Voor ons waren de belangrijkste thema&rsquo;s over 2021 onderwijskwaliteit, innovatie en technologie en de ontwikkelingen op het gebied van Leven lang ontwikkelen. Ook omdat we op deze vlakken komende jaren nog flink in beweging zijn.</v-quote>

        <v-author>–Fred van der Westerlaken, Voorzitter College van Bestuur</v-author>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    import Quote from '@/app/components/quotations';
    import QuoteAuthor from '@/app/components/quotation-author';

    export default {
        name: 'OntwikkelingIntroQuote',
        meta: {
            title: 'OntwikkelingIntroQuote',
            color: '#a5147e'
        },
        components: {
            'circles-layout': Circles,
            'v-quote': Quote,
            'v-author': QuoteAuthor
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
